// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"e603d286","230":"9e825c79","453":"95eeed9a"}[chunkId] + ".chunk.js";
};